import {ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { AsaxFrequencyViewService, AsaxResultTableService, Extremes } from 'asax-common';
import { debounceTime, tap } from 'rxjs';

@Component({
  selector: 'asax-frequency-view-frequency-view-chart-reset-boundaries-button',
  templateUrl: './frequency-view-chart-reset-boundaries-button.component.html',
  styleUrls: ['./frequency-view-chart-reset-boundaries-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FrequencyViewChartResetBoundariesButton {
  
  displayResetBoundariesButton: boolean = false;
  extremes: Extremes;
  wasTabChangedRecently: boolean = false;
  
  constructor(
    private readonly asaxFrequencyViewService: AsaxFrequencyViewService,
    private readonly asaxResultTableService: AsaxResultTableService,
    private readonly cdr: ChangeDetectorRef) {

      this.asaxFrequencyViewService.getZoomExtremes().pipe(
        tap(extremes => this.onExtremes(extremes))
      ).subscribe();
  
      this.asaxFrequencyViewService.getRowsTableExtremes().pipe(
        debounceTime(1000),
        tap(extremes => this.extremes = extremes),
        tap(extremes => this.onExtremes(extremes))
      ).subscribe();

      this.asaxResultTableService.getActiveTabId().pipe(
        tap( _ => this.wasTabChangedRecently = true))
      .subscribe();
    }

    private onExtremes(extremes: Extremes) {
      if (!this.wasTabChangedRecently) {
        if (this.extremes &&
            (this.extremes.from !== extremes.from ||
                this.extremes.to !== extremes.to)) {
            this.displayResetBoundariesButton = true;
        } else {
            this.displayResetBoundariesButton = false;
        }
        this.cdr.markForCheck();
      } else {
        this.wasTabChangedRecently = false;
      }
    }

    resetBoundaries() {
      this.displayResetBoundariesButton = false;
      this.asaxFrequencyViewService.setResetExtremes(this.extremes);
    }
}
